import React, { Component } from 'react';
import { Form, Input, Icon, Button, message } from 'antd';
import { hasErrors } from '../../common/utils';
import { resetPassword } from '../../common/fetch';

class ResetPassword extends Component {
	handleSubmit = async (e) => {
		const { pathname } = window.location;
		const { history } = this.props;
		const pathArray = pathname.split('/');
		const code = pathArray[pathArray.length - 1];
		if (code === 'reset-password') return;
		const { getFieldValue } = this.props.form;
		e.preventDefault();
		const body = {
			new_password: getFieldValue('newPw'),
			code: code
		};
		try {
			await resetPassword(body);
			message.success('Success to update Password. try again to login');
			history.replace('/login');
		} catch (error) {
			console.error(error);
			message.error('Error : ' + error.data.message);
		}
	};

	render() {
		const {
			getFieldDecorator,
			getFieldsError,
			getFieldError,
			isFieldTouched
		} = this.props.form;
		const newPwError = isFieldTouched('newPw') && getFieldError('newPw');
		const chkPwError = isFieldTouched('chkPw') && getFieldError('chkPw');
		return (
			<Form onSubmit={this.handleSubmit}>
				<Form.Item validateStatus={newPwError ? 'error' : ''}>
					{getFieldDecorator('newPw', {
						rules: [
							{
								required: true,
								message: 'Please input your new Password!'
							}
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: 'rgba(0,0,0,.25)' }}
								/>
							}
							type="password"
							placeholder="New Password"
						/>
					)}
				</Form.Item>
				<Form.Item validateStatus={chkPwError ? 'error' : ''}>
					{getFieldDecorator('chkPw', {
						rules: [
							{
								required: true,
								message: 'Please check your new Password!'
							}
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: 'rgba(0,0,0,.25)' }}
								/>
							}
							type="password"
							placeholder="Check Password"
						/>
					)}
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						block
						htmlType="submit"
						disabled={hasErrors(getFieldsError())}
					>
						Reset Password
					</Button>
				</Form.Item>
			</Form>
		);
	}
}

const WrappedResetPassword = Form.create({ name: 'reset form' })(ResetPassword);

export default WrappedResetPassword;
